import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setReduxAccessToken } from "../Redux/accessToken";
import axios from "axios";

function UseAuth (code) {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [accessToken, setAccessToken] = useState(sessionStorage.getItem('accessToken'));
  const [refreshToken, setRefreshToken] = useState(localStorage.getItem('refreshToken'));
  const [expiresIn, setExpiresIn] = useState(localStorage.getItem('expiresIn'));
  const dispatch = useDispatch();

  // Get access token
  useEffect(() => {
    try {
      const login = async () => {
        const response = await axios.post(baseUrl + 'login', {code});

        setAccessToken(response.data.accessToken);
        sessionStorage.setItem('accessToken', response.data.accessToken);
        dispatch(setReduxAccessToken(response.data.accessToken));
        setRefreshToken(response.data.refreshToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        setExpiresIn(response.data.expiresIn);
        localStorage.setItem('expiresIn', response.data.expiresIn);

        window.history.pushState({}, null, '/');
      }
        login();
      } catch (err) {
        console.error('Could not log in: ', err);
        window.location = '/';
      }
    }, [code, dispatch, baseUrl]);

  // Refresh access token
  useEffect(() => {
    if (!refreshToken || !expiresIn) return;

    const interval = setInterval(() => {
      axios
        .post(baseUrl + 'refresh', {
          refreshToken,
        })
        .then((response) => {
          setAccessToken(response.data.access_token);
          localStorage.setItem('accessToken', response.data.access_token);
          dispatch(setReduxAccessToken(response.data.accessToken));
          setExpiresIn(response.data.expires_in);
          localStorage.setItem('expiresIn', response.data.expires_in);
        })
        .catch((err) => {
          console.error('Could not refresh token: ', err);
          window.alert('Could not refresh token');
        });
    }, (expiresIn - 60) * 1000);

    return () => clearInterval(interval);
  }, [refreshToken, expiresIn, dispatch, baseUrl]);

  return accessToken;
}

export default UseAuth;
